module.exports = __webpack_public_path__ + "img/point.804b74cf.png";